export interface Quote {
  name: string;
  image: string;
  quote: React.ReactNode;
  author: string;
}

export const quotes: Quote[] = [
  {
    name: "Optimism",
    image: "/assets/companies/optimism.png",
    quote: (
      <p>
        With high performance, an expansive database, and curated tables, Dune
        provides us with a solid foundation to conduct onchain research in the
        open with the Optimism community. The paid plan has further enabled our
        team to build on our typical open source queries by using the API to
        join with additional data sources and automate our reporting. Unified
        credits give us the flexibility to increase our API usage or prioritized
        queries, depending on our needs at the time.
      </p>
    ),
    author: "Michael Silberling, Analyst at OP Labs",
  },
  {
    name: "Uniswap",
    image: "/assets/companies/uniswap.png",
    quote: (
      <p>
        At Uniswap Labs, we use Dune for market intelligence, protocol research,
        and information gathering. It is an important resource for the entire
        web3 community as we look to understand data and trends for Uniswap
        users and the industry at large.
      </p>
    ),
    author: "Austin Adams, Research at Uniswap",
  },
  {
    name: "Steakhouse Financial",
    image: "/assets/companies/steakfi.png",
    quote: (
      <p>
        We love the convenience of addressing our entire team in one plan, while
        catering to their diverse needs through the credit system.
      </p>
    ),
    author: "Sébastien Derivaux, Founding Chef at Steakhouse Financial",
  },
];
